import { Tooltip } from 'antd';
import { EmailNotificationOverallStatuses, EmailNotificationProviderStatuses } from 'types/common';
import { getEmailNotificationProps } from './utils';

type Props = {
    overallStatus: EmailNotificationOverallStatuses;
    providerStatus?: EmailNotificationProviderStatuses;
    dataTestId?: string;
};

const EmailNotificationStatusIcon = ({ overallStatus, providerStatus, dataTestId }: Props) => {
    if (overallStatus === 'NOT_SENT') {
        return null;
    }

    const { tooltip, icon } = getEmailNotificationProps(overallStatus, providerStatus);

    return (
        <Tooltip title={tooltip}>
            <span
                style={{
                    display: 'flex',
                    alignContent: 'center',
                }}
                data-testid={dataTestId}
            >
                {icon}
            </span>
        </Tooltip>
    );
};

export default EmailNotificationStatusIcon;
